import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import _ from "lodash";
import menuIcon from "images/menu-icon.svg";
import SeekView from "pages/seek";
import RecommendedAssets from "components/recommendedAssets";
import FrequentlyShared from "components/frequentlyShared";
import paperfliteLogo from "../../images/paperflite_logo.svg";
import defaultProfileIcon from "images/default_user_profile_background.png";
import contentLibrary from "images/content-library.svg";
import Conversations from "components/conversations";
import { fetchRecommendedAssets, invalidateRecommendedAssets } from "actions/assets";
import { fetchConversationActivity, invalidateConversationActivity } from "actions/conversations";
import StarterPlan from 'components/starterPlan';
import StarterLicencePlan from 'components/starterLicencePlan';

import cx from "classnames";
import styles from './paperfliteHome.module.scss';
import { setActiveCRM } from "actions/application";
import { trackAdoptionMetricsForConversationClickedEvent, trackAdoptionMetricsForSessionStartEvent } from "actions/adoption";
import { fetchUserAccount, fetchUserProfile, logoutUser } from "actions/users";
import { PF_GET_CURRENT_TAB_DETAILS } from "constants/actionTypes";
import AuthService from "services/auth.service";
import Meeting from "pages/meeting";
import { fetchDeals } from "actions/meeting";

export default function PaperfliteHome(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuRef = React.useRef(null);

  const [showRecommendedAssets, setShowRecommendedAssets] = useState(false);
  const [showConversationActivity, setShowConversationActivity] = useState(false);
  const [showSeek, setShowSeek] = useState(false);
  const [allowAttachAssets, setAllowAttachAssets] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [isCalendarTab, setIsCalendarTab] = useState(false);

  const profile = useSelector((state) => _.get(state, 'users.profile.item') || null);
  const frequentlySharedAssets = useSelector((state) => _.get(state, 'assets.frequentlyShared.items') || []);
  const recommendedAssets = useSelector((state) => _.get(state, 'assets.recommendedAssets.items') || []);
  const recommendedAssetsLoading = useSelector((state) => _.get(state, 'assets.recommendedAssets.loading')) || false;
  const recipientNames = useSelector((state) => _.get(state, 'selection.recipientNames') || []);
  const totalSharesCount = useSelector((state) => _.get(state, 'conversations.shares.totalShares', null));
  const userId = useSelector((state) => _.get(state, "users.profile.item.id")) || "";
  const integrations = useSelector((state) => _.get(state, "integrations.items")) || [];
  const loadingProfile = useSelector((state) => _.get(state, 'users.profile.loading'));
  const loadingAccount = useSelector((state) => _.get(state, 'users.account.loading'));
  const subscriptionPlan = useSelector((state) => _.get(state, 'users.account.item.subscription.subscriptionPlan.key')) || "";
  const userPlan = useSelector((state) => _.get(state,'users.profile.item.userRoles[0].key')) || "";
  const activeTab = useSelector((state) => _.get(state, 'application.activeTab')) || null;
  const meetingDetails = useSelector((state) => _.get(state, 'selection.meetingDetails')) || null;
  const dealDetails = useSelector((state) => _.get(state, 'selection.dealDetails')) || null;
  const fetchingDeals = useSelector((state) => _.get(state, "meeting.fetchingDeals") || false);

  const localActiveTab = AuthService.getActiveTab() || null;
  
  const isGmailIntegrationActivated = AuthService.isGmailIntegrationActivated() === "true" ? true : false;
  
  useEffect(() => {
    if(_.size(profile) === 0){
      dispatch(fetchUserAccount());
      dispatch(fetchUserProfile());
      dispatch(trackAdoptionMetricsForSessionStartEvent("Session Start"))
    }
  }, []);

useEffect(() => {
  function handleClickOutside(event) {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setShowMenu(false);
    }
  }

  if (showMenu) {
    document.addEventListener("click", handleClickOutside);
  } else {
    document.removeEventListener("click", handleClickOutside);
  }

  return () => {
    document.removeEventListener("click", handleClickOutside);
  };
}, [showMenu]);


  useEffect(() => {
    dispatch(setActiveCRM("GMAIL"))
    dispatch(invalidateConversationActivity());
    if (_.size(recipientNames) > 0) {    

      const today = new Date();
      const year = today.getUTCFullYear();
      const month = String(today.getUTCMonth() + 1).padStart(2, '0');
      const day = String(today.getUTCDate()).padStart(2, '0');
      const currentDate = `${year}-${month}-${day}T00:00:00+00:00`;

      const previousDate = new Date(today);
      previousDate.setUTCDate(today.getUTCDate() - 90);
      const previousYear = previousDate.getUTCFullYear();
      const previousMonth = String(previousDate.getUTCMonth() + 1).padStart(2, '0');
      const previousDay = String(previousDate.getUTCDate()).padStart(2, '0');
      const startDate = `${previousYear}-${previousMonth}-${previousDay}T00:00:00+00:00`;

      const request =
      {
        email: recipientNames[0],
        startDate: startDate,
        endDate: currentDate,
        filters: [
          {
            property: {
              type: "contact"
            },
            operator: "is",
            value: [""]
          }
        ],
        userType: "all",
        sortBy: "views"
      }

      dispatch(fetchConversationActivity(request));

      if (_.size(integrations) > 0) {
        const selectedIntegration = integrations.filter(item => item.type === "salesforce_v2" || item.type === "hubspot");
        if (_.size(selectedIntegration) > 0) {
          const request = {
            email: recipientNames[0],
            integration: selectedIntegration[0].id,
            user: userId
          }
          dispatch(fetchRecommendedAssets(request));
        }
      }


    } else {
      setShowRecommendedAssets(false);
      setShowConversationActivity(false);
      dispatch(invalidateRecommendedAssets());
    }
  }, [recipientNames])

  useEffect(() => {
    if (totalSharesCount > 0) {
      setShowConversationActivity(true);
    }else{
      setShowConversationActivity(false);
    }
    if (_.size(recommendedAssets) > 0) {
      setShowRecommendedAssets(true);
    }else{
      setShowRecommendedAssets(false);
    }
  }, [totalSharesCount, recommendedAssets])

  const triggerMessageToPlugin = (message) => {
    window.parent.postMessage(message, "*");
  }

 useEffect(() => {
    if(localActiveTab && activeTab && (localActiveTab === activeTab)){
      const isGmailActive = isGmailIntegrationActivated && activeTab && activeTab.includes("mail.google.com");
      const isCalendarActive = activeTab && activeTab.includes('calendar.google.com');
      if (isCalendarActive && _.size(meetingDetails) > 0 && _.size(dealDetails) > 0){
        setIsCalendarTab(true);
      } else {
        setIsCalendarTab(false);
      }
      if (isGmailActive){
        setAllowAttachAssets(true);
      } else {
        setAllowAttachAssets(false);
      }
    } else {
      triggerMessageToPlugin({
        type: PF_GET_CURRENT_TAB_DETAILS,
        payload: {}
      })
    }

    if(!isGmailIntegrationActivated){
      setAllowAttachAssets(false);
    }
  }, [activeTab, localActiveTab, isGmailIntegrationActivated, meetingDetails, dealDetails])

  if (subscriptionPlan === "starter") {
    return <StarterPlan />;
  }
  if (userPlan === "starter_licence") {
    return <StarterLicencePlan />;
  }

  const handleLogout = () => {
    dispatch(logoutUser(false));
    history.push("/login")
  }

  return (
    <>
      <div className={styles.container}>
      {!showSeek && (
      <div className={styles.headerContainer}>
      <img alt="Paperflite Logo" className={styles.logo} src={paperfliteLogo} />

        <div className={styles.actions}>
              
          <i
          className={cx(styles.menuIcon, styles.notificationIcon, "paperflite-notifications" )}
          onClick={() => {
          history.push("/notification");
          setShowMenu(false);
          }}
          />
          <span className={styles.dotContainer} ><span className={styles.dot} /> </span>

          <div className={styles.menuContainer} ref={menuRef}>
            <img
              alt="Menu Icon"
              className={styles.menuIcon}
              src={menuIcon}
              onClick={() => setShowMenu(!showMenu)}
            />
              {showMenu && (
                <div className={styles.menuPopup}>
                  <button
                    className={styles.menuItem}
                    onClick={() => {
                      handleLogout();
                      setShowMenu(false);
                    }}
                  >
                    <i className={cx("paperflite-upload", styles.logoutIcon)} />
                    <span>Logout</span>
                  </button>
                </div>
              )}
            </div>
          </div>
      </div>
      )}

      {loadingAccount && _.size(profile) == 0 && ( 
        <div className={styles.loadingAccount}>loading...</div>
      )}

      {((isCalendarTab && !loadingAccount && !loadingProfile) || (fetchingDeals) )&& (
        <Meeting />
      )}
      
         {!loadingAccount && !loadingProfile && !isCalendarTab && (
           <div>
             {!showSeek && <>
              <div onClick={() => {
                  dispatch(invalidateConversationActivity());
              }}>
              </div>
                <div className={styles.userDetails}>
                  {profile &&
                    <p className={styles.welcomeMessage}>Back at it, <span className={styles.profileName}>{profile.firstName}</span></p>
                  }
                  <img alt="Profile Icon" className={styles.profileIcon} src={profile ? _.get(profile, "icon.thumbnail") : defaultProfileIcon} />
                </div>
              </>
              }
      
              <SeekView setShowSeek={setShowSeek} showSeek={showSeek} attachAssets={allowAttachAssets} />
      
              {!showSeek && <>
                {!showConversationActivity && !showRecommendedAssets && 
                <div className={styles.actionsContainer}>
                 <p className={styles.actionsHeading}>
                  Need insights, content, or a quick share?
                </p>
                <div className={styles.actionButtons}>
                  <div
                    className={styles.actionButton}
                    onClick={() => {
                      history.push("/conversations?source=paperflite-home");
                      dispatch(
                        trackAdoptionMetricsForConversationClickedEvent(
                          "Conversation Clicked"
                        )
                      );
                    }}
                  >
                    <i className="paperflite-history" />
                    <p>Recent Activity</p>
                    <i className={cx("paperflite-up-arrow", styles.seeAllIcon)} />
                  </div>
                  <div
                    className={styles.actionButton}
                    onClick={() => history.push("/paperflite-content-library")}
                  >
                    <i className="paperflite-stream-access" />
                    <p>Browse Hub</p>
                    <i className={cx("paperflite-up-arrow", styles.seeAllIcon)} />
                  </div>
                </div>
                </div>}
      
                {showConversationActivity &&
                  <div>
                    <div className={styles.conversations}>
                      {totalSharesCount ?
                        (totalSharesCount > 0 ?
                          <span className={styles.conversationsContent}>
                            You've had {totalSharesCount} conversations in this previously.
                          </span> :
                          <span className={styles.conversationsContent}>
                            No shares
                          </span>) :
                        <span className={styles.conversationsContentLoading}>
                          loading...
                        </span>
                      }
                      <span className={cx(styles.rightArrow, {
                        [styles.showRightArrow]: totalSharesCount > 0
                      })} onClick={() => history.push('/conversation-activity')}>
                        <i className="paperflite-up-arrow" />
                      </span>
                    </div>
                    </div>
                    }
      
                {!showRecommendedAssets &&
                  <div className={styles.frequentlyShared}>
                    {frequentlySharedAssets.length > 0 &&
                      <span className={styles.seeAllContainer} onClick={() =>
                        allowAttachAssets ? history.push('/frequently-used') : history.push('/frequently-shared-assets')} >
                        <span className={styles.seeAll}>see all</span>
                        <i className={cx(styles.seeAllIcon, "paperflite-up-arrow")} />
                      </span>
                    }
                    <FrequentlyShared carousel={true} attachAssets={allowAttachAssets} />
                  </div>
                }
      
                    {showRecommendedAssets && recommendedAssets.length > 0 &&
                      <div className={styles.recommendedAssets}>
                        <span className={styles.seeAllContainer} onClick={() =>
                          history.push('/recommended-assets')} >
                          <span className={styles.seeAll}>SEE ALL</span>
                          <i className="paperflite-right-arrow" />
                        </span>
                        <RecommendedAssets carousel={true} />
                      </div>
                    }
                </>
            }
            </div>
          )}
      </div>
    </>
  );
}
